<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :renovationsActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "electrical",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "renovations/IMG-20180319-WA0011.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      }
    ],
    serviceTitle: "General renovations",
    serviceDescription:
      "We offer home Renovations are our specialty! That's why we love what we do, and why we offer a full range of renovation services painting and remodeling. "
  })
};
</script>
